export default [
  {
    path: '/learn/:openCourseId',
    component: () => import(/* webpackChunkName: "learn" */ '@/pages/learnModule/learn.vue'),
  },
  {
    path: '/notes/:curriculumId/:openCourseId',
    component: () => import(/* webpackChunkName: "learn" */ '@/pages/learnModule/notes.vue'),
  },
  {
    path: '/myCourse',
    component: () => import(/* webpackChunkName: "learn" */ '@/pages/learnModule/myCourse.vue'),
  },
];
